import { useShow } from '@refinedev/core';
import { IChild } from '../../interfaces/child';
import { Show } from '@refinedev/antd';
import { Card, Layout, Space, Typography } from 'antd';

export const ChildShow = () => {
  const { queryResult } = useShow<IChild>({
    meta: {
      fields: ['id'],
    },
  });
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading} title={`子供: ${record?.id}`}>
      <Space align="start">
        <Card dir="column">
          <Space direction="vertical"></Space>
        </Card>
        <Card></Card>
      </Space>
    </Show>
  );
};
